module.exports = __webpack_public_path__ + "img/help-plot.627e92ea.webp";